/* =========================

  which is name

============================ */
import styled from "styled-components";



/* -------------------------

  component

---------------------------- */
function Image( props ) {
  return (
    <Styled src={`${process.env.PUBLIC_URL}${props.src}`} alt={(props.alt)?props.alt:``} />
  );
}

export default Image;

/* -------------------------

  styled

---------------------------- */
const Styled = styled.img`
  max-width: 100%;
`
